module.exports = __webpack_public_path__ + "krav_marke_farg-65c4c73962a432f063e0f37d6a53f288.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/krav_marke_farg.png
// module id = 89
// module chunks = 0